import { render, staticRenderFns } from "./allpushform.vue?vue&type=template&id=3510f74a&scoped=true&"
import script from "./allpushform.vue?vue&type=script&lang=js&"
export * from "./allpushform.vue?vue&type=script&lang=js&"
import style0 from "./allpushform.vue?vue&type=style&index=0&id=3510f74a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3510f74a",
  null
  
)

export default component.exports